(function () {
	function hotspotSlider() {
		const sliders = document.querySelectorAll(".product-banner-slider");

		if (sliders.length) {
			sliders.forEach(slider => {
				const id = slider.dataset.sectionId;

				const swiperHotspotSlider = new Swiper(`.product-banner-slider-${id}.product-banner-slider-thumbs .swiper`, {
					loop: true,
					speed: 800,
					slidesPerView: 1,
					spaceBetween: 0,
					navigation: {
						nextEl: `.product-banner-slider-${id} .slider-arrow-next`,
						prevEl: `.product-banner-slider-${id} .slider-arrow-prev`,
					},
					keyboard: {
						enabled: true,
						onlyInViewport: false,
					},
				});
			})
		};
	}

	document.addEventListener('DOMContentLoaded', hotspotSlider);
	document.addEventListener('shopify:section:load', hotspotSlider);
})();